import { Component, OnInit, Inject, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { AlertComponent } from 'ngx-bootstrap/alert/alert.component';
import { SESSION_STORAGE, WebStorageService } from 'ngx-webstorage-service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';

import { ExcelUtility } from '../../../common/util/ExcelUtility';
import { TransferStore } from '../../../common/model/TransferStore';
import { TransferStoreFacade } from '../../../common/facade/TransferStoreFacade';
import { StoreFacade } from '../../../common/facade/StoreFacade';
import { Permissions } from '../../../common/model/dictionary/Permissions';
import { Strings } from '../../../common/language/strings';
import { res } from '../../../common/language/text/res';
import { Organization } from '../../../common/model/Organization';


@Component({
  selector: 'app-transfer-store',
  templateUrl: './transfer-store.component.html',
  styleUrls: ['./transfer-store.component.css']
})
export class TransferStoreComponent implements OnInit {
  // modal
  @ViewChild('modal') public modal: ModalDirective;
  validateMessage: any
  fileName = ""
  fileData = ""

  public res = res;
  titleStoreTransfers = res.StoreTransfers;
  lblDownload = res.Download;
  lblOriginStore = res.OriginStore;
  lblDestinationStore = res.DestinationStore;
  lblSelectAnOption = res.SelectAnOption;
  lblSearch = res.Search;
  lblTransferReference = res.TransferReference;
  lblShipment = res.Shipment;
  lblEntry = res.Entry;
  lblOrganization = res.Organization;
  lblStartDate = res.StartDate;
  lblEndDate = res.EndDate;
  errorSmallerThan = res.SmallerDateThan;
  errorGreaterThan = res.GreaterDateThan;
  lblPackageCollectionDate = res.PackageCollectionDate;
  lblEmployeeCollectionConfirm = res.EmployeeCollectionConfirm;
  lblGuideCollection = res.GuideCollection;
  lblCommentCollection = res.CommentCollection;
  lblShippingNumber = res.ShippingNumber;

  isSpanish = true;
  language = 0

  messagesTable: any = {
    emptyMessage: "",
    totalMessage: ""
  }

  loading = false;
  messageLoader = '';
  // alert
  alerts = [];
  // filters
  storeOriginId = -1;
  storesOrigin = [];
  storeDestinyId = -1;
  storesDestiny = [];
  startDate = new Date();
  endDate = new Date();

  lstOrganization: Organization[] = [];
  availableOrganizations: Organization[] = [];
  selectedOrganizations: Organization[] = [];
  public organizationSelected: any[] = [];
  strOrganizationSelected: string;
  tenantId: number;

  storeId = -1;
  tmpStoreId
  organizationId: string;

  //permissions
  permissionsList: any[] = []
  visibleAdd = false
  visibleEdit = false
  visibleDownloadInvoice = false
  rows: TransferStore[] = [];
  private _filteredData: TransferStore[] = [];
  searchTransfer = false;
  showStoreFilter = false;

  constructor(
    @Inject(SESSION_STORAGE) private _storage: WebStorageService,
    private _excel: ExcelUtility,
    private _router: Router,
    private _route: ActivatedRoute,
    private _transferStoreFacade: TransferStoreFacade,
    private _facadeStore: StoreFacade,
    public _datepipe: DatePipe,
    public strings: Strings,
    private localeService: BsLocaleService,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.isSpanish = this.strings.getLanguageIsSpanish();
    this.availableOrganizations = this.strings.getAvailableOrganizations();
    this.tenantId = this.strings.getTenant();
    this.lstOrganization = this.availableOrganizations.filter(item => item.tenantId == this.tenantId);
    this.startDate = new Date();
    this.endDate = new Date();

    this.messagesTable.emptyMessage = this.strings.GetText(res.ThereIsNoInformation);
    this.messagesTable.totalMessage = 'Total';

    if (!this.isSpanish) {
      this.language = 1
    }

    this.validatePermissions()
    this.localeService.use(this.strings.getLanguage());

    this._route.queryParams.subscribe(params => {
      if (params['startDate'] !== undefined && params['endDate'] !== undefined) {
        this.endDate = new Date(params['endDate']);
        this.startDate = new Date(params['startDate']);
        this.searchTransfer = true
      }

      if (params['orgId'] !== undefined) {
        this.organizationId = params['orgId'];
        this.strOrganizationSelected = this.organizationId;
        this.organizationSelected = this.lstOrganization.filter(org => this.organizationId.includes(org.organizationId));
        this.selectedOrganizations = this.lstOrganization;
        this.getStores();
      }

      if (this.searchTransfer) {
        if (params['storeOriginId'] !== undefined && Number(params['storeOriginId']) > -1) {
          this.storeOriginId = Number(params['storeOriginId']);
        }

        if (params['storeDestinyId'] !== undefined && Number(params['storeDestinyId']) > -1) {
          this.storeDestinyId = Number(params['storeDestinyId']);
        }

        this.getTransferRequest();
      }
    });

    this.loading = false;

  }

  getTransferRequest() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.Loading);
    if (this.startDate > this.endDate) {
      this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertTheStartDateCannotBeHigher), 'danger')
      this.loading = false;
    }
    else {
      this._transferStoreFacade.GetAllTransferStore(this.startDate, this.endDate, this.strOrganizationSelected).subscribe(
        response => {
          if (response.completed && response.data.length > 0) {
            this.showStoreFilter = true
          }
          else {
            this.showStoreFilter = false
          }
          this.rows = response.data;
          this._filteredData = response.data;
          this.loading = false;
        }, error => {
          this.loading = false;
          this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertTheTransfersCouldNotBeObtained), 'danger');
        }
      );
    }
  }

  private getStores() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.GettingTheStores);
    this._facadeStore.GetParticipateQuantum().subscribe(
      response => {
        this.loading = false;
        this.storesOrigin = response.data;
        this.storesDestiny = response.data;
      }, error => {
        this.loading = false;
        this.addAlert('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertStoresCouldNotBeObtained), 'danger');
      }
    );
  }

  // añadir alert
  addAlert(message: String, type: String) {
    this.alerts = [];
    this.alerts.push({
      type: type,
      msg: message
    });
  }

  // cerrar alert
  onClosed(dismissedAlert: AlertComponent) {
    this.alerts = this.alerts.filter(alert => alert !== dismissedAlert);
  }

  // filter Transfer
  onStoreOriginChange() {
    this.storeDestinyId = -1;
    if (this.storeOriginId.toString() === '-1') {
      this.rows = this._filteredData;
    } else {
      this.rows = this._filteredData.filter(item => {
        return (item.storeOriginId.toString() === this.storeOriginId.toString());
      });
    }
  }

  onStoreDestinyChange() {
    this.storeOriginId = -1;
    if (this.storeDestinyId.toString() === '-1') {
      this.rows = this._filteredData;
    } else {
      this.rows = this._filteredData.filter(item => {
        return (item.storeDestinationId.toString() === this.storeDestinyId.toString());
      });
    }
  }

  updateFilter(event) {
    // get the value of the key pressed and make it lowercase
    const val = event.target.value.toLowerCase();
    // get the key names of each column in the dataset
    const keys = Object.keys(this._filteredData[0]);
    // assign filtered matches to the active datatable
    this.rows = this._filteredData.filter(function (item) {
      // iterate through each row's column data
      for (let i = 0; i < keys.length; i++) {
        if (item[keys[i]] != null && (item[keys[i]].toString().toLowerCase().indexOf(val) !== -1 || !val)) {
          return true;
        }
      }
    });
  }

  downloadInvoiceListZip(transferStoreId: number) {
    this.loading = true

    this._transferStoreFacade.GetInvoiceListFile(transferStoreId, this.language).subscribe(result => {
      if (result.completed) {
        this.fileName = transferStoreId.toString()
        this.fileData = result.data
        this.validateMessage = result.message

        if (result.message.length <= 0) {
          this.getFile()
        }
        else {
          this.getHtml()
          this.modal.show()
        }
      }
      else {
        this.addAlert(result.message, 'danger')
      }

      this.loading = false
    }, error => {
      this.loading = false
      this.addAlert(error, 'danger')
    }
    );
  }

  getFile() {
    try {
      if (this.fileData != null) {
        const filename = this.fileName + ".zip";
        const blobData = this.convertBase64ToBlobData(this.fileData);
        const nav = (window.navigator as any);

        if (window.navigator && nav.msSaveOrOpenBlob) { //IE
          nav.msSaveOrOpenBlob(blobData, filename);
        } else { // chrome
          const blob = new Blob([blobData], { type: 'application/octet-stream' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = filename;
          link.click();
        }
      }
      this.modal.hide()
    }
    catch
    {
      this.addAlert(this.strings.GetText(res.AlertOperationCouldNotBeCompleted), 'danger')
    }
  }

  getHtml(): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(this.validateMessage);
  }

  convertBase64ToBlobData(base64Data: string, contentType: string = 'application/zip', sliceSize = 512) {
    const byteCharacters = atob(base64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  // Save excel
  downloadLayout() {
    if (this.rows.length > 0) {
      const data: any = [];
      this.rows.forEach(row => {
        const info = {
          [this.strings.GetText(res.TransferReference)]: String(row.transferStoreId),
          [this.strings.GetText(res.ShippingNumber)]: String(row.referenceShippingType),
          [this.strings.GetText(res.SendDate)]: this.isSpanish ? this._datepipe.transform(row.insertedDate, 'dd/MM/yyyy') : this._datepipe.transform(row.insertedDate, 'yyyy/MM/dd'),
          [this.strings.GetText(res.PackageCollectionDate)]: this.isSpanish ? this._datepipe.transform(row.packageCollectionDate, 'dd/MM/yyyy') : this._datepipe.transform(row.packageCollectionDate, 'yyyy/MM/dd'),
          [this.strings.GetText(res.OriginStore)]: row.storeOriginName,
          [this.strings.GetText(res.DestinationStore)]: row.storeDestinationName,
          [this.strings.GetText(res.Shipment)]: row.percentSend,
          [this.strings.GetText(res.Entry)]: row.percentReceived
        };
        data.push(info);
      });
      this._excel.exportAsExcelFile(data, 'data');
    } else {
      this.addAlert(this.strings.GetText(res.AlertInfoMustBeLoadedToGenerateTheFile), 'danger');
    }
  }

  // go toDetail
  onViewDetail(id) {

    const navigationExtras: NavigationExtras = {
      queryParams: {
        'startDate': this.startDate.toDateString(),
        'endDate': this.endDate.toDateString(),
        'orgId': this.strOrganizationSelected,
        'storeOriginId': this.storeOriginId,
        'storeDestinyId': this.storeDestinyId
      }
    };
    this._router.navigate(['/transfer/store/', id], navigationExtras);
  }

  validatePermissions() {
    this.permissionsList = this._storage.get('permissions')
    this.permissionsList.forEach(element => {
      if (element.name == Permissions.GeneralAccess || element.name == Permissions.AdminTraspasoCorpoCreate) {
        this.visibleAdd = true;
      }
    });

    this.permissionsList.forEach(element => {
      if (element.name == Permissions.GeneralAccess || element.name == Permissions.AdminTraspasoCorpoEdit) {
        this.visibleEdit = true;
      }
    });

    this.permissionsList.forEach(element => {
      if (element.name == Permissions.InvoiceTransfer || element.name == Permissions.GeneralAccess) {
        this.visibleDownloadInvoice = true;
      }
    });
  }

  onChangeStartDate(value) {
    this.startDate = this.subtractTimeFromDate(value, 6);
  }

  onChangeEndDate(value) {
    this.endDate = this.subtractTimeFromDate(value, 6);
  }

  onChangeOrganization(selected) {
    this.selectedOrganizations = selected;
    this.strOrganizationSelected = this.selectedOrganizations.map(e => e.organizationId).join(',');
    this.getStores();
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  subtractTimeFromDate(objDate, intHours) {
    var numberOfMlSeconds = objDate.getTime();
    var addMlSeconds = intHours * 60 * 60000;
    var newDateObj = new Date(numberOfMlSeconds - addMlSeconds);
    return newDateObj;
  }

}
